import React, { useRef, useEffect, useState } from 'react';
import { counters } from '../../data/portfolioData';

const Counter = ({ end, label }) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !started.current) {
        started.current = true;
        let start = 0;
        const duration = 2500;
        const step = Math.ceil(end / (duration / 30));
        const timer = setInterval(() => {
          start += step;
          if (start >= end) { setCount(end); clearInterval(timer); }
          else setCount(start);
        }, 30);
      }
    }, { threshold: 0.5 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [end]);

  return (
    <div className="counter-item" ref={ref}>
      <span className="counter-number">{count}</span>
      <p className="counter-label">{label}</p>
    </div>
  );
};

const CountersSection = () => (
  <div
    className="counters-section section-block"
    id="counters"
    style={{ backgroundImage: 'url(/images/cover_bg_1.jpg)' }}
  >
    <div className="counters-overlay" />
    <div className="counters-grid">
      {counters.map(c => <Counter key={c.id} end={c.end} label={c.label} />)}
    </div>
  </div>
);

export default CountersSection;
